module.exports = __webpack_public_path__ + "static/media/11.13ae547c.svg";